// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2LCqY","content":"styles_content__slsQx","checkbox":"styles_checkbox__HCc-S","checkboxLabel":"styles_checkboxLabel__1toA1"};